
import { FormatService } from 'services/FormatService'
export default class GambleDynamicText extends PIXI.Text {
  constructor(data) {

    super(data.text, data.style)
    this._data = data
    this.anchor.set(0.5, 0.5)
    this.name = data.name

  }

  get data(){
    return this._data
  }

  checkSize() {
    if (this.width > this.data.width && this.style.fontSize > 1) {
      this.resize()
    }
  }

  resize() {
    this.style.fontSize--
    this.checkSize()
  }
  /**
     * The distance between two points
     * @param {String} value
     * @private
     */
  update(value) {
    this.text = FormatService.currency(value)
    this.style.fontSize = this.data.style.fontSize
    this.checkSize()
  }
}
